export default "__VITE_ASSET__CWv7x6Gr__"